import * as XLSX from 'xlsx';
import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { SLOT_CONFIGS } from '../constants/slotRegistry';
import { buildSheetRows, applyNumberFormats, EXPORT_HEADERS_COUNT } from '../utils/inventoryExport';

export async function exportInventoryToExcel(
  api: ApiClient,
  artEventId: string | null | undefined,
  selectedSlotKeys?: string[]
): Promise<void> {
  if (!artEventId) {
    throw new Error('Art Event ID is required for export');
  }

  const configs = selectedSlotKeys
    ? SLOT_CONFIGS.filter((config) => selectedSlotKeys.includes(config.key))
    : SLOT_CONFIGS;

  if (configs.length === 0) {
    throw new Error('No slots selected for export');
  }

  const workbook = XLSX.utils.book_new();
  let hasData = false;

  const results = await Promise.allSettled(
    configs.map((config) => config.fetchFn(api, artEventId))
  );

  results.forEach((result, index) => {
    const config = configs[index];

    if (result.status === 'fulfilled' && result.value?.slotPackages?.length) {
      const data = result.value;
      const rows = buildSheetRows(data);
      const ws = XLSX.utils.aoa_to_sheet(rows);

      const slotPackageCount = data.slotPackages.length;
      const hasSuper = slotPackageCount > 1;
      applyNumberFormats(ws, slotPackageCount, hasSuper);

      const colCount = 1 + slotPackageCount * EXPORT_HEADERS_COUNT;
      ws['!cols'] = Array.from({ length: colCount }, (_, i) => ({
        wch: i === 0 ? 25 : 18,
      }));

      XLSX.utils.book_append_sheet(workbook, ws, config.sheetName);
      hasData = true;
    } else {
      const ws = XLSX.utils.aoa_to_sheet([
        ['No data available for this slot type'],
      ]);
      XLSX.utils.book_append_sheet(workbook, ws, config.sheetName);
    }
  });

  if (!hasData) {
    throw new Error('No inventory data available to export');
  }

  const filename = `${artEventId}-inventory-export.xlsx`;
  XLSX.writeFile(workbook, filename);
}
